<template>
    <div>
        <div
            class="card"
            v-if="canInvoice"
        >
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-12">
                        <h3>Invoicing</h3>
                    </div>
                </div>
                <form
                    action=""
                    @submit.prevent="saveInvoiceDetails()"
                    class="form-inline row"
                >
                    <div class="input-group col-12 col-md-2">
                        <label for="invoiced_at">Invoiced On:</label>
                        <date-picker
                            v-model="form.invoiced_at"
                            id="invoiced_at"
                            :options="{format: 'L'}"
                            required
                        />
                        <error
                            :errors="errors"
                            name="invoiced_at"
                        />
                    </div>
                    <div class="input-group col-12 col-md-3">
                        <label for="invoiced_by_id">Action By:</label>
                        <select
                            name="invoiced_by_id"
                            v-model="form.invoiced_by_id"
                            id="invoiced_by_id"
                            class="form-control"
                            placeholder="Staff"
                        >
                            <option
                                :value="null"
                                disabled
                            >
                                Select user
                            </option>
                            <option
                                v-for="user in officeStaff"
                                :key="user.id"
                                :value="user.id"
                            >
                                {{ user.name }}
                            </option>
                        </select>
                        <error
                            :errors="errors"
                            name="invoiced_by_id"
                        />
                    </div>
                    <button
                        class="btn btn-primary"
                        type="submit"
                        style="align-self: flex-end"
                    >
                        Save Invoice Details
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import UsersService from '../../../services/UsersService';
import UsesErrors from "../../../mixins/UsesErrors";
import UsesInfoMessage from '../../../mixins/UsesInfoMessage';
import AuthService from '../../../services/AuthService';
import DatePicker from '../../DateTimePickerComponent';
import FormService from '../../../services/FormService';

export default {
    components: {
        DatePicker,
    },
    mixins: [
        UsesInfoMessage,
        UsesErrors,
    ],

    props: {
        form: {
            type: Object,
            required: true,
        },
    },

    data: function () {
        return {
            officeStaff: [],
        };
    },

    computed: {
        canInvoice: function () {
            return (AuthService.user.admin_access || AuthService.user.office_access) && this.form && this.form.id;
        },
    },

    watch: {
        form: {
            immediate: true,
            handler () {
                if (!this.form) {
                    return;
                }
                this.form.invoiced_at = this.form.invoiced_at ? window.moment(this.form.invoiced_at) : '';
            },
        }
    },

    created () {
        this.loadOfficeStaff();
    },

    methods: {
        saveInvoiceDetails () {
            FormService.update(this.form).then(
                () => {
                    this.setInfoMessage('Invoice details saved');
                }, () => {
                    this.setErrorMessage('Could not save invoice details');
                }
            );
        },

        loadOfficeStaff () {
            UsersService.officeStaff().then(
                res => {
                    this.officeStaff = res.data;
                },
                err => {
                    this.setErrorMessage('Failed to load office staff');
                    throw err;
                });
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/parts/InvoiceFormComponent.vue